import type { QueryClient } from '@tanstack/react-query'

import { readCommercePosDraft } from '@/lib/commerce-pos-draft-storage'
import storeCommerceApi from '@/services/store-commerce'

/** Matches `OfferPlatformType.IN_STORE` / POS basket list. */
export const COMMERCE_HEADER_BASKET_SOURCE_TYPE_IN_STORE = 1

export function commerceHeaderBasketCountQueryKey(serviceInstanceId: string | null | undefined) {
  return ['commerce-header-basket-count', String(serviceInstanceId ?? '').trim()] as const
}

export function invalidateCommerceHeaderBasketCountQueries(queryClient: QueryClient) {
  void queryClient.invalidateQueries({ queryKey: ['commerce-header-basket-count'] })
}

/** Total items in the persisted POS draft basket (sum of row quantities). */
export async function fetchCommerceHeaderBasketItemCount(
  serviceInstanceId: string | null | undefined,
): Promise<number> {
  const sid = String(serviceInstanceId ?? '').trim()
  if (!sid) {
    return 0
  }

  const draft = readCommercePosDraft(sid)
  const orderId = draft?.orderId?.trim()
  if (!orderId) {
    return 0
  }

  const raw = await storeCommerceApi.listBasket({
    order: orderId,
    source_type: COMMERCE_HEADER_BASKET_SOURCE_TYPE_IN_STORE,
  })

  const rows = Array.isArray(raw.results) ? (raw.results as Record<string, unknown>[]) : []
  let sum = 0
  for (const row of rows) {
    const qty = Number(row.quantity ?? row.variant_quantity ?? 1)
    sum += Number.isFinite(qty) ? Math.max(0, qty) : 0
  }
  return sum
}
